import React from "react";

const MAIN_COLOR = getComputedStyle(document.documentElement)
	.getPropertyValue("--main-color")
	.trim();
const MAIN_COLOR_DARK = getComputedStyle(document.documentElement)
	.getPropertyValue("--main-color-dark")
	.trim();

const ErrorIcon = (props) => {
	return (
		<svg
			width="30"
			height="30"
			viewBox="0 0 30 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<g id="Icon/Emoji Sad">
				<path
					id="Subtract"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M14.9987 28.2904C22.3395 28.2904 28.2904 22.3395 28.2904 14.9987C28.2904 7.65791 22.3395 1.70703 14.9987 1.70703C7.65791 1.70703 1.70703 7.65791 1.70703 14.9987C1.70703 22.3395 7.65791 28.2904 14.9987 28.2904ZM9.26168 9.97902C9.43524 9.6319 9.89857 8.95715 10.7697 8.95715C11.6407 8.95715 12.1041 9.6319 12.2776 9.97902C12.4873 10.3984 12.5822 10.8932 12.5822 11.3738C12.5822 11.8544 12.4873 12.3492 12.2776 12.7686C12.1041 13.1157 11.6407 13.7905 10.7697 13.7905C9.89857 13.7905 9.43524 13.1157 9.26168 12.7686C9.05198 12.3492 8.95715 11.8544 8.95715 11.3738C8.95715 10.8932 9.05198 10.3984 9.26168 9.97902ZM17.72 9.97902C17.8936 9.6319 18.3569 8.95715 19.228 8.95715C20.0991 8.95715 20.5624 9.6319 20.736 9.97902C20.9457 10.3984 21.0405 10.8932 21.0405 11.3738C21.0405 11.8544 20.9457 12.3492 20.736 12.7686C20.5624 13.1157 20.0991 13.7905 19.228 13.7905C18.3569 13.7905 17.8936 13.1157 17.72 12.7686C17.5103 12.3492 17.4155 11.8544 17.4155 11.3738C17.4155 10.8932 17.5103 10.3984 17.72 9.97902ZM9.70767 19.6523L10.1643 20.4351C9.70767 19.6523 9.7079 19.6522 9.70814 19.6521L9.70866 19.6518L9.70984 19.6511L9.71277 19.6494L9.72093 19.6447L9.74634 19.6304C9.76728 19.6187 9.79618 19.6028 9.83269 19.5833C9.90568 19.5445 10.0093 19.4912 10.1408 19.4285C10.4034 19.3031 10.7792 19.139 11.2459 18.9756C12.1759 18.6501 13.4877 18.3206 14.9976 18.3206C16.5076 18.3206 17.8194 18.6501 18.7494 18.9756C19.2161 19.139 19.5918 19.3031 19.8545 19.4285C19.986 19.4912 20.0896 19.5445 20.1626 19.5833C20.1991 19.6028 20.228 19.6187 20.2489 19.6304L20.2743 19.6447L20.2825 19.6494L20.2854 19.6511L20.2866 19.6518L20.2871 19.6521C20.2874 19.6522 20.2876 19.6523 19.831 20.4351L19.3743 21.2179L19.3651 21.2128C19.3544 21.2068 19.3361 21.1967 19.3106 21.1831C19.2595 21.1559 19.1797 21.1147 19.0738 21.0642C18.8618 20.963 18.547 20.8251 18.1506 20.6863C17.3544 20.4077 16.2496 20.1331 14.9976 20.1331C13.7457 20.1331 12.6409 20.4077 11.8446 20.6863C11.4483 20.8251 11.1335 20.963 10.9215 21.0642C10.8156 21.1147 10.7358 21.1559 10.6847 21.1831C10.6592 21.1967 10.6409 21.2068 10.6301 21.2128L10.6205 21.2182C10.1883 21.47 9.63362 21.324 9.38151 20.8918C9.12932 20.4594 9.27534 19.9045 9.70767 19.6523ZM19.3751 21.2184L19.3751 21.2184L19.3748 21.2182C19.3746 21.2181 19.3743 21.2179 19.831 20.4351L20.2876 19.6523C20.7199 19.9045 20.866 20.4594 20.6138 20.8918C20.3619 21.3235 19.8083 21.4697 19.3762 21.219L19.3751 21.2184Z"
					fill="url(#paint0_linear_4506_246519)"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_4506_246519"
					x1="14.9987"
					y1="1.70703"
					x2="14.9987"
					y2="28.2904"
					gradientUnits="userSpaceOnUse">
					<stop stopColor={MAIN_COLOR} />
					<stop
						offset="1"
						stopColor={MAIN_COLOR_DARK}
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default ErrorIcon;
